import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@dxb-web-ui-framework/design-system';
import { MatchButtons } from '../../../../content-composer/src/components/Generic/MatchButtons';

type StepperActionsProps = {
  isMobile: boolean;
  isLoading: boolean;
  onClickCancel: () => void;
  onClickNext?: () => void;
  isConfirmationStep?: boolean;
};

const StepperActions: FC<StepperActionsProps> = ({
  isMobile,
  onClickCancel,
  onClickNext,
  isLoading,
  isConfirmationStep,
}) => {
  const { t } = useTranslation();
  return (
    <Box mt={isMobile ? 5 : 'auto'} mb={isMobile ? 4 : 0} width='100%'>
      <Box display={'flex'} justifyContent={!isMobile ? 'flex-end' : 'flex-start'}>
        <MatchButtons
          isFullWidth={false}
          leftBtnFullWidth
          isLeftBtnDisabled={isLoading}
          onClickLeftBtn={onClickCancel}
          leftBtnLabel={t('fundsTransferPage.StepperActions.Back')}
          rightBtnFullWidth
          isRightBtnDisabled={isLoading}
          onClickRightBtn={onClickNext}
          rightBtnLabel={
            Boolean(isConfirmationStep)
              ? t('fundsTransferPage.StepperActions.Confirm')
              : t('fundsTransferPage.StepperActions.Next')
          }
        />
      </Box>
    </Box>
  );
};

export { StepperActions };
